import script from "./DetalhesOrdemCompraCompleto.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesOrdemCompraCompleto.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesOrdemCompraCompleto.vue?vue&type=style&index=0&id=430492a7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430492a7"]])

export default __exports__